<template>
  <div class="consulting">
    <div class="consulting__hero">
      <div class="consulting__hero-container">
        <div class="consulting__hero-contents">
          <div class="consulting__hero-title">세무사와 상담하기</div>
          <p class="consulting__hero-description">
            전화번호를 남기시면 세무사가<br />
            직접 연락드립니다.
          </p>
        </div>
      </div>
    </div>

    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit" class="form">
        <input id="uuid" v-model="uuid" hidden />

        <ValidationProvider
          v-slot="{ errors }"
          name="상담유형 "
          mode="lazy"
          rules="required"
          slim
        >
          <div class="form__field consulting-form">
            <label class="label label--required" for="phone_number"
              >상담 유형</label
            >
            <a
              href="https://overtax.channel.io"
              target="_blank"
              class="channel-talk-link"
              >더낸세금 문의</a
            >
            <label
              :class="{
                'radio-box--selected': lead_type === 'biz'
              }"
              class="radio-box"
            >
              <input
                v-model="lead_type"
                value="biz"
                class="radio-box__input"
                type="radio"
                name="상담유형"
              />
              <div class="radio-box__circle"></div>
              <div class="radio-box__content">
                <div class="radio-box__title">
                  사업자 기장 상담
                </div>
                <p class="radio-box__description">
                  사업자 세금 신고, 사업장 절세 관련 문의, 법인전환 문의
                </p>
              </div>
            </label>
            <label
              :class="{
                'radio-box--selected': lead_type === 'general'
              }"
              class="radio-box"
            >
              <input
                v-model="lead_type"
                value="general"
                class="radio-box__input"
                type="radio"
                name="상담유형"
              />
              <div class="radio-box__circle"></div>
              <div class="radio-box__content">
                <div class="radio-box__title">양도 상속 증여 상담</div>
                <p class="radio-box__description">
                  양도, 상속, 증여, 기타 비사업자 세무 문의
                </p>
              </div>
            </label>
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
          </div>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          :rules="{
            required: true,
            numeric: true,
            regex: /^(01[016789]|02|0[3-9][1-5]|070)\d{3,4}\d{4}$/
          }"
          name="전화번호"
          slim
        >
          <div class="form__field">
            <label class="label label--required" for="phone_number"
              >전화번호</label
            >
            <input
              id="phone_number"
              v-model="phone"
              class="input"
              name="phone_number"
              type="tel"
              placeholder="전화번호를 입력해주세요."
            />
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
          </div>
        </ValidationProvider>

        <ValidationProvider
          v-if="lead_type === 'biz'"
          v-slot="{ errors }"
          :rules="{
            required: true,
            businessNumber: true
          }"
          name="사업자등록번호"
          slim
        >
          <div class="form__field">
            <label class="label label--required" for="business_number"
              >사업자등록번호</label
            >
            <input
              id="business_number"
              v-model="businessNumber"
              @input="handleInputBusinessNumber"
              class="input"
              name="business_number"
              type="text"
              placeholder="사업자등록번호를 입력해주세요."
            />
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
          </div>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          name="서비스이용약관 "
          mode="lazy"
          rules="required"
          slim
        >
          <div class="form__field">
            <input
              id="서비스이용약관"
              v-model="termsOfService"
              class="checkbox"
              name="termsOfService"
              type="checkbox"
            />
            <span class="label-checkbox label-checkbox--required"
              ><a href="https://page.heumtax.com/terms" target="_blank"
                >서비스 이용약관</a
              >
              동의</span
            >
            <p class="validation-msg">
              {{ errors[0] ? '필수 동의 항목입니다.' : '' }}
            </p>
          </div>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          name="개인정보처리방침 "
          mode="lazy"
          rules="required"
          slim
        >
          <div class="form__field">
            <input
              id="개인정보처리방침"
              v-model="privacyStatement"
              class="checkbox"
              name="privacy-statement"
              type="checkbox"
            />
            <span class="label-checkbox label-checkbox--required"
              ><a href="https://page.heumtax.com/privacy-policy" target="_blank"
                >개인정보 수집/이용 동의</a
              >
            </span>
            <p class="validation-msg">
              {{ errors[0] ? '필수 동의 항목입니다.' : '' }}
            </p>
          </div>
        </ValidationProvider>

        <ValidationProvider name="마케팅수신 " mode="lazy" slim>
          <div class="form__field">
            <input
              id="마케팅수신"
              v-model="termsOfMarketing"
              class="checkbox"
              name="terms-of-marketing"
              type="checkbox"
            />
            <span class="label-checkbox"
              ><a href="/terms-of-marketing" target="_blank">마케팅 수신</a>
              동의 (선택)</span
            >
          </div>
        </ValidationProvider>

        <div class="form__field">
          <button
            :disabled="processing"
            type="submit"
            class="btn btn--primary form__submit"
          >
            상담 신청하기
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider, Validator } from 'vee-validate'
import bizNumberValidator from '../../utils/bizNumberValidator'
import consulting from '~/components/mixins/consulting.js'

Validator.extend('businessNumber', {
  getMessage: () => '올바른 사업자등록번호가 아닙니다.',
  validate: bizNumberValidator
})

export default {
  layout: 'invert-font-header',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [consulting],
  data() {
    return {
      businessNumber: '',
      phone: '',
      lead_type: '',
      termsOfService: null,
      privacyStatement: null,
      termsOfMarketing: false
    }
  },
  watch: {
    termsOfService: {
      handler(value) {
        if (value === false) {
          this.termsOfService = null
        }
      }
    },
    privacyStatement: {
      handler(value) {
        if (value === false) {
          this.privacyStatement = null
        }
      }
    }
  },
  mounted() {
    this.checkOvertaxLead()
  },
  methods: {
    async checkOvertaxLead() {
      const { phone: utmPhone, ouid: utmOuid } = this.utmParams
      const { phone: queryPhone, ouid: queryOuid } = this.$route.query

      if (utmPhone && utmOuid) {
        await this.navigateToConsultingDetail(utmPhone, utmOuid)
        return
      }

      if (queryPhone && queryOuid) {
        await this.navigateToConsultingDetail(queryPhone, queryOuid)
      }
    },
    async navigateToConsultingDetail(phone, ouid) {
      await this.consultationRequestWapper('overtax', {
        ...this.utmParams,
        phone,
        ouid
      })
      await this.$router.push({
        path: '/consulting-detail',
        query: { phone, ouid }
      })
    },
    async consultationRequestWapper(endpoint, data) {
      await this.$nuxt.$loading.start()
      await this.requestLeadApi('post', endpoint, data)
        .then((res) => {
          if (!res) return
          localStorage.setItem('phone', this.phone)
          localStorage.setItem('businessNumber', this.businessNumber)
          localStorage.setItem('termsOfMarketing', this.termsOfMarketing)
          localStorage.setItem('personId', res.person_id)
          localStorage.setItem('dealId', res.deal_id)
          localStorage.setItem('noteId', res.note_id)
        })
        .finally(() => {
          this.$nuxt.$loading.finish()
        })
    },
    async consultationRequest() {
      await this.consultationRequestWapper('online', {
        ...this.utmParams,
        phone: this.phone,
        business_number: this.businessNumber,
        ga_code: this.uuid,
        lead_type: this.lead_type,
        agree_to_marketing: this.termsOfMarketing,
        marketing_agreement_date: this.termsOfMarketing
          ? this.$moment().format('YYYY-MM-DD')
          : null
      })

      // leadType은 광고 최적화를 위한 파라미터
      await this.$router.push({
        path: '/consulting-detail',
        query: { leadType: this.lead_type }
      })

      return Promise.resolve()
    },
    handleInputBusinessNumber(e) {
      const newValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 10)
      this.businessNumber = newValue
      e.target.value = newValue
    }
  }
}
</script>

<style scoped lang="scss">
.consulting-form {
  position: relative;

  .channel-talk-link {
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    padding: 0 0 2px 0;
    color: #6f7176;
    font-size: 15px;
    text-decoration: none;

    &:hover {
      border-bottom: 1px solid #6f7176;
    }
  }
}

.event-banner {
  margin-bottom: 2rem;
  padding: 24px;
  background-image: url('/images/consulting/bg_event_banner.png');
  background-position: 94% 50%;
  background-repeat: no-repeat;
  background-color: #edf3ff;
  background-size: 40%;
  border-radius: 5px;

  @include av-mq(lap-and-up) {
    background-size: initial;
  }

  .title {
    margin-bottom: 8px;
    font-family: Noto Sans CJK KR;
    font-style: normal;
    line-height: 24px;
    color: #000000;
    font-size: 17px;
    font-weight: 700;

    span {
      color: #1b5fe5;
    }

    small {
      color: #1b5fe5;
      font-size: 11px;
      font-weight: 300;
    }
  }

  .description {
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
  }
}

.event-banner-image {
  margin-bottom: 2rem;
  border-radius: 5px;
  overflow: hidden;

  img {
    max-width: 100%;
  }
}
</style>
